module.exports = __webpack_public_path__ + "static/media/poveredUPI.58f37395.svg";